import type { AxiosError } from 'axios';

export const handleQueryError = (e: AxiosError | Error | any | null) =>
  e ? e?.response?.data?.errors?.[0] || e?.data?.errors?.[0] || e?.message || 'Unknown error.' : '';
